import { useEffect } from 'react';

import { setValueToLocalStorage, getValueFromLocalStorage, PAGES_HISTORY } from '../../helpers';

import type { TCpasPageHistorySave } from './models';

type TPageInfo = {
    date: string;
    id: string;
};

export const CpasPageHistorySave = ({
    deletePageAfterVisit = true,
    id,
    timeBeforeDelete,
}: TCpasPageHistorySave) => {
    const getCurrentTime = () => {
        return new Date().toLocaleString('en-US', { hour12: false });
    };

    const addPageToHistory = (history: TPageInfo[]) => {
        history.push({ id, date: getCurrentTime() });
        setValueToLocalStorage(PAGES_HISTORY, history);
    };

    const updatePageVisitDate = (history: TPageInfo[], index: number) => {
        history[index].date = getCurrentTime();
        setValueToLocalStorage(PAGES_HISTORY, history);
    };

    const deletePageFromHistory = (history: TPageInfo[], index: number) => {
        history.splice(index, 1);
        setValueToLocalStorage(PAGES_HISTORY, history);
    };

    useEffect(() => {
        const history = getValueFromLocalStorage(PAGES_HISTORY, '[]');
        const pageIndex = history.findIndex((page: TPageInfo) => page.id === id);

        if (pageIndex === -1) {
            addPageToHistory(history);
        } else {
            const lastVisitDate = new Date(history[pageIndex].date);
            const timeSinceLastVisit =
                new Date(getCurrentTime()).getTime() - lastVisitDate.getTime();

            const deleteTimeInMs = timeBeforeDelete * 60000;

            if (deletePageAfterVisit && timeSinceLastVisit >= deleteTimeInMs) {
                deletePageFromHistory(history, pageIndex);
            } else if (!deletePageAfterVisit) {
                updatePageVisitDate(history, pageIndex);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, deletePageAfterVisit, timeBeforeDelete]);

    return null;
};
